import { Component } from '@angular/core';
import { MemberService } from '../../services/member.service';

@Component({
  selector: 'def-menu-burger',
  templateUrl: './def-menu-burger.component.html',
  styleUrls: ['./def-menu-burger.component.scss'],
})
export class DefMenuBurgerComponent {

  readonly gaCategory = 'Menu Burger';

  constructor(private memberService: MemberService) { }

  logout() {
    this.memberService.userLogout();
  }
}
